import React, { Component } from "react";
import axios from "axios";
import pds from "../../helpers/pds";
import paounits from "../../helpers/paounits";

class WarrantModalEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            PartitionKey: this.props.recordInfo.PartitionKey._,
            RowKey: this.props.recordInfo.RowKey._,
            sequenceNo: this.props.recordInfo.sequenceNo._,
            warrantNo: this.props.recordInfo.warrantNo._,
            isSealed: this.props.recordInfo.isSealed._,
            isSealedUnlocked: false,
            approvingDPA: this.props.recordInfo.approvingDPA._,
            approvingDPAUnlocked: false,
            detectiveName: this.props.recordInfo.detectiveName._,
            detectiveNameUnlocked: false,
            agency: this.props.recordInfo.agency._,
            agencyUnlocked: false,
            paoUnit: this.props.recordInfo.paoUnit._,
            paoUnitUnlocked: false,
            caseNumber: this.props.recordInfo.caseNumber._,
            caseNumberUnlocked: false
        };
        this.closeModal = this.closeModal.bind(this);
        this.editRecord = this.editRecord.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    closeModal() {
        this.props.closeModal();
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
    
        this.setState({ [name]: value });
    }
    editRecord() {
        const toPost = { 
            "PartitionKey": this.state.PartitionKey, 
            "RowKey": this.state.RowKey,
            "sequenceNo": this.state.sequenceNo,
            "warrantNo": this.state.warrantNo,
            "detectiveName": this.state.detectiveName,
            "agency": this.state.agency,
            "paoUnit": this.state.paoUnit,
            "caseNumber": this.state.caseNumber,
            "isSealed": (this.state.isSealed === "true" || this.state.isSealed === true),
            "approvingDPA": this.state.approvingDPA
        }
        axios.post("/insertMergeRecord", toPost).then(() => {
            this.props.closeModalAndRefresh();
        });
    }
    render() {
        const pdList = [];
        const paoUnitList = [];
        pds.forEach((pd, index) => {
          pdList.push(
            <option key={"pdOption--Modal" + index} value={pd}>
              {pd}
            </option>
          );
        });
        paounits.forEach((unit, index) => {
          paoUnitList.push(
            <option key={"paoUnitOption--Modal" + index} value={unit}>
              {unit}
            </option>
          );
        });
        return (
            <div className="warrantModalEdit">
                <div className="warrantModalEdit__container">
                    <div className="warrantModalEdit__header">
                        <div>Editing {this.props.recordInfo.warrantNo._}</div>
                        <div className="warrantModalEdit__headerExit"
                            onClick={this.closeModal}>
                                &times;
                        </div>
                    </div>
                    <div className="warrantModalEdit__body">
                        <div className="warrantModalEdit__bodyText">
                            <p>
                                Check the checkbox next to the field you would like to edit to unlock it. When finished, click on the "Edit" button at the bottom to finalize changes. Click on the "Cancel" button to abort changes.
                            </p>
                        </div>
                        <div className="warrantModalEdit__bodyInput">
                            <div className="warrantModalEdit__bodyInputRow">
                                <div className="warrantNoEdit__bodyInputLabelContainer">
                                    <label 
                                        className="warrantNoEdit__bodyInputLabel" 
                                        htmlFor="detectiveName">
                                            Detective's Full Name
                                    </label>
                                </div>
                                <input 
                                    type="text" 
                                    name="detectiveName"
                                    className="warrantNoEdit__bodyInputElem" 
                                    value={this.state.detectiveName} 
                                    disabled={!this.state.detectiveNameUnlocked}
                                    onChange={this.handleInputChange}
                                />
                                <input
                                    type="checkbox"
                                    name="detectiveNameUnlocked"
                                    className="warrantNoEdit__bodyInputToggle" 
                                    checked={this.state.detectiveNameUnlocked}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="warrantModalEdit__bodyInputRow">
                                <div className="warrantNoEdit__bodyInputLabelContainer">
                                    <label 
                                        className="warrantNoEdit__bodyInputLabel" 
                                        htmlFor="caseNumber">
                                            Agency Case Number
                                    </label>
                                </div>
                                <input 
                                    type="text" 
                                    name="caseNumber"
                                    className="warrantNoEdit__bodyInputElem" 
                                    value={this.state.caseNumber} 
                                    disabled={!this.state.caseNumberUnlocked}
                                    onChange={this.handleInputChange}
                                />
                                <input
                                    type="checkbox"
                                    name="caseNumberUnlocked"
                                    className="warrantNoEdit__bodyInputToggle" 
                                    checked={this.state.caseNumberUnlocked}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="warrantModalEdit__bodyInputRow">
                                <div className="warrantNoEdit__bodyInputLabelContainer">
                                    <label 
                                        className="warrantNoEdit__bodyInputLabel" 
                                        htmlFor="agency">
                                            Agency
                                    </label>
                                </div>
                                <select
                                    name="agency"
                                    className="warrantNoEdit__bodyInputElem" 
                                    value={this.state.agency}
                                    disabled={!this.state.agencyUnlocked}
                                    onChange={this.handleInputChange}
                                >
                                    {pdList}
                                </select>
                                <input
                                    type="checkbox"
                                    name="agencyUnlocked"
                                    className="warrantNoEdit__bodyInputToggle" 
                                    checked={this.state.agencyUnlocked}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="warrantModalEdit__bodyInputRow">
                                <div className="warrantNoEdit__bodyInputLabelContainer">
                                    <label 
                                        className="warrantNoEdit__bodyInputLabel" 
                                        htmlFor="approvingDPA">
                                            DPA Name
                                    </label>
                                </div>
                                <input 
                                    type="text" 
                                    name="approvingDPA"
                                    className="warrantNoEdit__bodyInputElem" 
                                    value={this.state.approvingDPA} 
                                    disabled={!this.state.approvingDPAUnlocked}
                                    onChange={this.handleInputChange}
                                />
                                <input
                                    type="checkbox"
                                    name="approvingDPAUnlocked"
                                    className="warrantNoEdit__bodyInputToggle" 
                                    checked={this.state.approvingDPAUnlocked}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="warrantModalEdit__bodyInputRow">
                                <div className="warrantNoEdit__bodyInputLabelContainer">
                                    <label 
                                        className="warrantNoEdit__bodyInputLabel" 
                                        htmlFor="paoUnit">
                                            PAO Unit
                                    </label>
                                </div>
                                <select
                                    name="paoUnit"
                                    className="warrantNoEdit__bodyInputElem" 
                                    value={this.state.paoUnit}
                                    disabled={!this.state.paoUnitUnlocked}
                                    onChange={this.handleInputChange}
                                >
                                    {paoUnitList}
                                </select>
                                <input
                                    type="checkbox"
                                    name="paoUnitUnlocked"
                                    className="warrantNoEdit__bodyInputToggle" 
                                    checked={this.state.paoUnitUnlocked}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="warrantModalEdit__bodyInputRow">
                                <div className="warrantNoEdit__bodyInputLabelContainer">
                                    <label 
                                        className="warrantNoEdit__bodyInputLabel" 
                                        htmlFor="isSealed">
                                            Sealed
                                    </label>
                                </div>
                                <select
                                    name="isSealed"
                                    className="warrantNoEdit__bodyInputElem" 
                                    value={this.state.isSealed}
                                    disabled={!this.state.isSealedUnlocked}
                                    onChange={this.handleInputChange}
                                >
                                    <option key="isSealedOption--Modal-True" value={true}>
                                        Yes
                                    </option>
                                    <option key="isSealedOption--Modal-True" value={false}>
                                        No
                                    </option>
                                </select>
                                <input
                                    type="checkbox"
                                    name="isSealedUnlocked"
                                    className="warrantNoEdit__bodyInputToggle" 
                                    checked={this.state.isSealedUnlocked}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="warrantModalEdit__bodyButtons">
                            <button 
                                type="button" 
                                className={"warrantModalEdit__bodyButton warrantModalEdit__bodyButton--edit"}
                                onClick={this.editRecord}>
                                    Edit
                            </button>
                            <button 
                                type="button" 
                                className="warrantModalEdit__bodyButton"
                                onClick={this.closeModal}>
                                    Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WarrantModalEdit;